import type { Brand } from 'types/brands'

// Returns all subbrands of a list of brands
export const getSubbrands = (brands: Brand[]) =>
	brands.flatMap((brand) => brand.subBrands || [])
